import { RAZORPAY_TEST_KEY_ID, getRandomString, promReduxConnect, isCourseAlreadySubscribed, getOrderPaymentStatus, ensureLoggedIn, RAZORPAY_PROD_KEY_ID, isUrlLocalOrDev } from "../util/utils";
import { PureComponent } from "react"
import "./course.css"
import { promAxios } from "../../store/promAxios";
import { checkLoginSaga, getMyOrdersSaga, getSubscriptionsSaga } from "../../store/common.saga";
import { reduxStateUpdateAddOrder, reduxStateUpdateSubscriptions } from "../../store/common.reducer";
import './programs.scss'
import { PromSpinnerComponent, PromSpinnerComponent2 } from "../util/spinner";


export class RegisterProgramComponentInternal extends PureComponent {
    state = {}
    componentDidMount() {
        const urlSearchParams = new URLSearchParams(this.props.location.search)
        this.setState({batchId: urlSearchParams.get("batchId")})
        this.setState({courseId: urlSearchParams.get("courseId")})
        this.props.dispatchFunctionAction(getSubscriptionsSaga, {})
    }

    sendEmailVerificationCode = (email) => {
        promAxios.post(`/api/v1/users/sendEmailVerificationCode`).then(response => {
            this.setState({emailVerificationCodeSent: true})
        })
    }

    sendPhoneNumberVerificationCode = (email) => {
        promAxios.post(`/api/v1/users/sendPhoneNumberVerificationCode`, {
            phoneNumber: this.state.enteredPhoneNumber
        }).then(response => {
            this.setState({phoneNumberVerificationCodeSent: true})
        })
    }

    validateEmailVerificationCode = () => {
        const { enteredEmailVerificationCode } = this.state
        promAxios.get(`/api/v1/users/verifyEmail?code=${enteredEmailVerificationCode}`).then(response => {
            this.props.dispatchFunctionAction(checkLoginSaga, {})
        })
    }

    validatePhoneNumberVerificationCode = () => {
        const { enteredPhoneNumberVerificationCode } = this.state
        promAxios.get(`/api/v1/users/verifyPhoneNumber?code=${
            enteredPhoneNumberVerificationCode}`).then(response => {
            this.props.dispatchFunctionAction(checkLoginSaga, {})
        })
    }

    onCreateOrder = (order) => {
        promAxios.post(`/api/v1/orders`, order).then(response => {
            this.props.dispatchFunctionAction(reduxStateUpdateAddOrder, {order: response.data})
            this.props.navigate(`/app/order?orderId=${response.data.orderId}`)
        })
    }

    render = () => {
        const {
            userId, email, emailVerified,
            allSubscriptions, allBatches, allCourses } = this.props
        const { batchId, courseId } = this.state

        const { user, loginStatus, navigate } = this.props
        const batch = Object.values(allBatches || {}).find(batch => batch?.batchId === batchId)
        ensureLoggedIn(loginStatus, navigate)
        if (!user) {
            return null
        }
        if (batchId && !batch) {
            return null
        }
        if ((!batchId && !courseId) || loginStatus !== "loggedIn") {
            return null
        }

        if (!emailVerified) {
            return <div className="d-flex flex-column verification-container">
                <div>Email not verified. Please verify email.</div>
                <div className="d-flex align-items-center field-container">
                    <div className="detail-field">{email}</div>
                    {this.state.emailVerificationCodeSent ?
                        <div className="input-field-container">
                            <input value={this.state.enteredEmailVerificationCode} onChange={(e) => {
                                this.setState({enteredEmailVerificationCode: e.target.value})
                            }}></input>
                            <div className="dashboardActionButton ms-2" onClick={() => {
                                this.validateEmailVerificationCode()
                            }}>Enter</div>
                        </div>:
                        <div className="verified-button-container">
                            <div className="dashboardActionButton" onClick={() => {
                                this.sendEmailVerificationCode()
                            }}>Send Code</div>
                        </div>
                    }
                </div>
            </div>
        }
        // if (!tempPhoneNumberVerified) {
        //     return <div className="d-flex flex-column mobile-verification-container">
        //         <div>Phone number not verified. Please verify phone number.</div>
        //         <div className="d-flex align-items-center phone-field-container">
        //             <div>
        //                 <input value={this.state.enteredPhoneNumber} onChange={(e) => {
        //                     this.setState({enteredPhoneNumber: e.target.value})
        //                 }}></input>
        //             </div>
        //             {this.state.phoneNumberVerificationCodeSent ?
        //                 <div className="input-field-container">
        //                     <input value={this.state.enteredPhoneNumberVerificationCode} onChange={(e) => {
        //                         this.setState({enteredPhoneNumberVerificationCode: e.target.value})
        //                     }}></input>
        //                     <div className="dashboardActionButton ms-2" onClick={() => {
        //                         this.validatePhoneNumberVerificationCode()
        //                     }}>Enter</div>
        //                 </div>:
        //                 <div className="dashboardActionButton" onClick={() => {
        //                     this.sendPhoneNumberVerificationCode()
        //                 }}>Send Code</div>}
        //         </div>
        //     </div>
        // }

        if (courseId) {
            const isAlreadyRegistered = isCourseAlreadySubscribed({allSubscriptions, courseId})
            if (isAlreadyRegistered) {
                return <div className="mobile-verification-container">You are already registered.
                Please access the course in My Learning and contact support for any questions.</div>
            }

            const course = allCourses?.[courseId]
            if (!course) {
                return null
            }

            this.onCreateOrder({
                orderItems: [{
                    orderItemId: getRandomString(),
                    orderItemType: "courseFee",
                    courseId: course.courseId,
                    price: course.price
                }]
            })
            return null
        }

        const subscription = allSubscriptions?.find(subscription => subscription?.batchId === batchId)
        const program = {}
        if (batchId.includes("pydev")) {
            program.programId = "pydev"
            program.programName = "Python Developer Internship"
        }

        const isRegistrationFeePaid = subscription?.subscriptionStatus === "registrationFeePaid"
        const isFullFeePaid = subscription?.subscriptionStatus === "fullFeePaid"
        let fullFee = batch?.price?.quantity/100
        let registrationFee = batch?.registrationFee?.quantity/100
        if (isRegistrationFeePaid) {
            fullFee = fullFee - batch?.registrationFee?.quantity / 100
        }

        if (isFullFeePaid) {
            return <div className="mobile-verification-container">You are already registered.
             Please contact support if you have any questions.</div>
        }

        return <div className="program-card-container">
            <div className="title">{program.programName}</div>
            <div className="tab-container">
                <div className="duration">

                    <div>{`${batch?.programDuration?.quantity} ${batch?.programDuration?.unit}`}</div>
                    <div className="sub-text">
                        <svg x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24">
                            <path d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z"></path>
                        </svg> Duration
                    </div>
                </div>
                <div className="start-info">  { new Date(batch.batchStartDate)?.toDateString()}
                    <div className="sub-text"><svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.16667 18.3332C3.70833 18.3332 3.31597 18.17 2.98958 17.8436C2.66319 17.5172 2.5 17.1248 2.5 16.6665V4.99984C2.5 4.5415 2.66319 4.14914 2.98958 3.82275C3.31597 3.49637 3.70833 3.33317 4.16667 3.33317H5V1.6665H6.66667V3.33317H13.3333V1.6665H15V3.33317H15.8333C16.2917 3.33317 16.684 3.49637 17.0104 3.82275C17.3368 4.14914 17.5 4.5415 17.5 4.99984V16.6665C17.5 17.1248 17.3368 17.5172 17.0104 17.8436C16.684 18.17 16.2917 18.3332 15.8333 18.3332H4.16667ZM4.16667 16.6665H15.8333V8.33317H4.16667V16.6665ZM4.16667 6.6665H15.8333V4.99984H4.16667V6.6665ZM10 11.6665C9.76389 11.6665 9.56597 11.5866 9.40625 11.4269C9.24653 11.2672 9.16667 11.0693 9.16667 10.8332C9.16667 10.5971 9.24653 10.3991 9.40625 10.2394C9.56597 10.0797 9.76389 9.99984 10 9.99984C10.2361 9.99984 10.434 10.0797 10.5938 10.2394C10.7535 10.3991 10.8333 10.5971 10.8333 10.8332C10.8333 11.0693 10.7535 11.2672 10.5938 11.4269C10.434 11.5866 10.2361 11.6665 10 11.6665ZM6.66667 11.6665C6.43056 11.6665 6.23264 11.5866 6.07292 11.4269C5.91319 11.2672 5.83333 11.0693 5.83333 10.8332C5.83333 10.5971 5.91319 10.3991 6.07292 10.2394C6.23264 10.0797 6.43056 9.99984 6.66667 9.99984C6.90278 9.99984 7.10069 10.0797 7.26042 10.2394C7.42014 10.3991 7.5 10.5971 7.5 10.8332C7.5 11.0693 7.42014 11.2672 7.26042 11.4269C7.10069 11.5866 6.90278 11.6665 6.66667 11.6665ZM13.3333 11.6665C13.0972 11.6665 12.8993 11.5866 12.7396 11.4269C12.5799 11.2672 12.5 11.0693 12.5 10.8332C12.5 10.5971 12.5799 10.3991 12.7396 10.2394C12.8993 10.0797 13.0972 9.99984 13.3333 9.99984C13.5694 9.99984 13.7674 10.0797 13.9271 10.2394C14.0868 10.3991 14.1667 10.5971 14.1667 10.8332C14.1667 11.0693 14.0868 11.2672 13.9271 11.4269C13.7674 11.5866 13.5694 11.6665 13.3333 11.6665ZM10 14.9998C9.76389 14.9998 9.56597 14.92 9.40625 14.7603C9.24653 14.6005 9.16667 14.4026 9.16667 14.1665C9.16667 13.9304 9.24653 13.7325 9.40625 13.5728C9.56597 13.413 9.76389 13.3332 10 13.3332C10.2361 13.3332 10.434 13.413 10.5938 13.5728C10.7535 13.7325 10.8333 13.9304 10.8333 14.1665C10.8333 14.4026 10.7535 14.6005 10.5938 14.7603C10.434 14.92 10.2361 14.9998 10 14.9998ZM6.66667 14.9998C6.43056 14.9998 6.23264 14.92 6.07292 14.7603C5.91319 14.6005 5.83333 14.4026 5.83333 14.1665C5.83333 13.9304 5.91319 13.7325 6.07292 13.5728C6.23264 13.413 6.43056 13.3332 6.66667 13.3332C6.90278 13.3332 7.10069 13.413 7.26042 13.5728C7.42014 13.7325 7.5 13.9304 7.5 14.1665C7.5 14.4026 7.42014 14.6005 7.26042 14.7603C7.10069 14.92 6.90278 14.9998 6.66667 14.9998ZM13.3333 14.9998C13.0972 14.9998 12.8993 14.92 12.7396 14.7603C12.5799 14.6005 12.5 14.4026 12.5 14.1665C12.5 13.9304 12.5799 13.7325 12.7396 13.5728C12.8993 13.413 13.0972 13.3332 13.3333 13.3332C13.5694 13.3332 13.7674 13.413 13.9271 13.5728C14.0868 13.7325 14.1667 13.9304 14.1667 14.1665C14.1667 14.4026 14.0868 14.6005 13.9271 14.7603C13.7674 14.92 13.5694 14.9998 13.3333 14.9998Z"
                            fill="#DB3D35"
                        />
                    </svg>
                        Start Date
                    </div>
                </div>
            </div>

            <div className="fee-container"> Rs. {fullFee}</div>
            <div className="notes-container"> <div>{subscription?.subscriptionStatus === "registrationFeePaid" ?
                `You already paid the registration fee.` :
                `Rs. ${registrationFee} (Will be set off against program fee while paying full fee).`}</div>
                <div>Refund Policy: Full refund if you join the program and leave within first 5 days.</div></div>

            <div className="pay-button-container">
                {!isRegistrationFeePaid && !isFullFeePaid ? <div className="dashboardActionButton inverseVariant ms-2" onClick={() => {
                    this.onCreateOrder({
                        orderItems: [{
                            orderItemId: getRandomString(),
                            orderItemType: "batchRegistrationFee",
                            batchId: batchId,
                            price: {
                                quantity: batch?.registrationFee?.quantity,
                                unit: "paisa"
                            }
                        }]
                    })
                }}>Pay Registration Fee and Register</div> : null}
                {!isFullFeePaid ? <div className="dashboardActionButton   ms-2" onClick={() => {
                    this.onCreateOrder({
                        orderItems: [{
                            orderItemId: getRandomString(),
                            orderItemType: "batchFee",
                            batchId: batchId,
                            price: {
                                quantity: fullFee*100,
                                unit: "paisa"
                            }
                        }]
                    })
                }}>Pay Full Fee and Register</div>: null}
            </div>
        </div>
    }
}

export const RegisterProgramComponent = promReduxConnect(RegisterProgramComponentInternal, (state, ownProps) => {
    return {
        userId: state.common.user?.userId,
        user: state.common.user,
        loginStatus: state.common.loginStatus,
        email: state.common.user?.email,
        emailVerified: state.common.user?.emailVerified,
        // tempPhoneNumberVerified: state.common.user?.tempPhoneNumberVerified,
        allSubscriptions: state.common.allSubscriptions,
        allBatches: state.common.allBatches,
        allCourses: state.common.allCourses
    };
})

const TableContainer = (props) => {
    const { order } = props;
    const getFullFee = (amount, unit) => {
        if (unit === 'paisa') {
            return amount / 100
        }
        return amount
    }

    const getOrderTypeText = (type) => {
        if (type === "batchFee") return "Batch Fee";
        if (type === 'batchRegistrationFee') return 'Batch Registration Fee'
        if (type==='courseFee') return 'Course Fee'
        return type
    }
    return <div className="d-flex flex-column">{(order?.orderItems || []).map(orderItem => {
        return <div className="d-flex table-container">

            <div className="table-main-row">
                <div className="table-main-header">Order Type</div>
                <div className="table-main-value">{getOrderTypeText(orderItem?.orderItemType) ?? "-"}</div>
            </div>

            <div className="table-main-row">
                <div className="table-main-header"> Batch ID
                </div>
                <div className="table-main-value">{orderItem?.batchId ?? "-"}</div>
            </div>
            <div className="table-main-row">
                <div className="table-main-header">Course ID</div>
                <div className="table-main-value">{orderItem?.courseId ?? "-"}</div>
            </div>
            <div className="table-main-row">
                <div className="table-main-header">Order Item ID</div>
                <div className="table-main-value">{orderItem?.orderItemId}</div>
            </div>
            <div className="table-main-row">
                <div className="table-main-header">Price</div>
                <div className="table-main-value">Rs. &nbsp;
                    {getFullFee(orderItem?.price?.quantity, orderItem?.price?.unit) ?? "-"} </div>
            </div>
        </div>

    })}</div>
}

export class OrderComponentInternal extends PureComponent {
    state = {} 

    componentDidMount() {
        const urlSearchParams = new URLSearchParams(this.props.location.search)
        this.setState({orderId: urlSearchParams.get("orderId")})
        this.props.dispatchFunctionAction(getMyOrdersSaga, {})
    }

    onRazorPay = () => {
        const { orderId } = this.state
        const order = this.props.orders[orderId]
        this.setState({paymentInProgress: true})
        promAxios.post(`/api/v1/razorpayInit`, {
            orderId
        }).then(response => {
            const razorpayOrderId = response.data.razorpayOrderId
            const transactionId = response.data.transactionId

            this.props.dispatchFunctionAction(reduxStateUpdateAddOrder, {order: response.data.order})
            const options = {
                key:  isUrlLocalOrDev() ? RAZORPAY_PROD_KEY_ID : RAZORPAY_TEST_KEY_ID,
                amount: `${order?.orderItems?.[0]?.price?.quantity || 0}`,
                currency: "INR",
                name: "Plovi",
                description: "Test Transaction",
                image: "https://example.com/your_logo",
                order_id: razorpayOrderId,

                modal: {
                    ondismiss: (a) => {
                        promAxios.post(`/api/v1/razorpayFinish`, {
                            orderId,
                            transactionId,
                            razorpayOrderId
                        }).then(response => {
                            this.props.dispatchFunctionAction(
                                reduxStateUpdateAddOrder, {order: response.data.order})
                            this.props.dispatchFunctionAction(
                                reduxStateUpdateSubscriptions,
                                {subscriptions: response.data.subscriptions})
                            
                            this.setState({paymentInProgress: false})
                        })
                    }
                },
                handler: (res) => {
                    const { razorpay_order_id, razorpay_payment_id, razorpay_signature } = res

                    promAxios.post(`/api/v1/razorpayFinish`, {
                        orderId,
                        transactionId,
                        razorpayOrderId,
                        razorpayPaymentId: razorpay_payment_id,
                        razorpaySignature: razorpay_signature
                    }).then(response => {
                        this.props.dispatchFunctionAction(
                            reduxStateUpdateAddOrder, {order: response.data.order})
                        this.props.dispatchFunctionAction(
                            reduxStateUpdateSubscriptions,
                            {subscriptions: response.data.subscriptions})
                        
                        this.setState({paymentInProgress: false})
                    })
                },
                prefill: {
                    name: "",
                    email: this.props.email,
                    contact: this.props.phoneNumber,
                },
                notes: {
                address: "Razorpay Corporate Office",
                },
                theme: {
                color: "#3399cc",
                },
            };

            const rzpay = new Razorpay(options);
            rzpay.open();
        })
    }

  
    render = () => {
        const { orderId } = this.state
        const { allSubscriptions, allCourses } = this.props
        const order = this.props.orders[orderId]
        if (!orderId || !order) {
            return null
        }
        const paymentInProgress = this.state.paymentInProgress
        // const paymentInProgress = true

        // if (order?.orderItems?.[0]?.orderItemType === "courseFee" && isCourseAlreadySubscribed({
        //     allSubscriptions,
        //     allCourses,
        //     courseId: order?.orderItems?.[0]?.courseId

        // })) {
        //     return <div className="order-component-card">You are already registered.
        //     <br></br>Please access the course in My Learning and contact support for any questions.</div>
        // }

        const orderStatus = order?.orderStatus
        const paymentStatus = getOrderPaymentStatus(order)

        if ((order?.orderItems?.length || 0) > 1) {
            return <div className="order-component-card">Please contact support@plovi.ai</div>
        }

        if (orderStatus === "fullfilled" && order?.orderItems?.[0]?.orderItemType === "batchRegistrationFee") {
            return <div  className="order-component-card">Registration confirmed. 
            Please wait to hear from our support.</div>
        }
        if (orderStatus === "fullfilled" && order?.orderItems?.[0]?.orderItemType === "batchFee") {
            return <div  className="order-component-card">Registration confirmed.
             Please wait to hear from our support.</div>
        }
        if (orderStatus === "fullfilled" && order?.orderItems?.[0]?.orderItemType === "courseFee") {
            return <div  className="order-component-card">Registration confirmed.
             Please access the course in My learning.</div>
        }

        if (paymentStatus === "failed") {
            return <div  className="order-component-card">Payment failed.
             Please try again or contact support@plovi.ai</div>
        }

        if (orderStatus !== "fullfilled" && paymentStatus === "paid") {
            return <div  className="order-component-card">Payment received. Order will be processed in a few minutes.
            Please contact support@plovi.ai if it takes longer.</div>
        }

        if (Object.keys(order?.paymentTransactions || {}).length > 0) {
            return <div  className="order-component-card">Payment processing...
            <br></br> 
            Please contact support if you have any questions.</div>
        }

        return <div className="d-flex flex-column order-component-card">
            <div className="title">Order ID <span className="order-id">{order?.orderId}</span></div>

            <TableContainer order={order} />
            {paymentInProgress &&
            <PromSpinnerComponent2 isActive={true}
                    messageText={"Processing..."}></PromSpinnerComponent2>}
            
            <div className="payment-button-container">
                <div className=""><div className="primaryActionButton  w-100" onClick={
                    this.onRazorPay
                }>Pay</div></div>
            </div>
            
        </div>
    }
}

export const OrderComponent = promReduxConnect(OrderComponentInternal, (state, ownProps) => {
    return {
        orders: state.common.orders,
        email: state.common.user?.email,
        phoneNumber: state.common.user?.phoneNumber,
        allSubscriptions: state.common.allSubscriptions,
        allCourses: state.common.allCourses,
    };
})


class MyOrdersComponentInternal extends PureComponent {
    state={
        selectedOrderIndex:[]
    }
    componentDidMount = () => {
        this.props.dispatchFunctionAction(getMyOrdersSaga, {})
    }
    
    onOrderOpenClick = (index)=>{
        this.setState((prevState)=>{
            let filteredSelectedIndex = [...prevState?.selectedOrderIndex];
            if(filteredSelectedIndex?.includes(index)){
                filteredSelectedIndex=filteredSelectedIndex?.filter(item=>item!==index);
            }else{
                filteredSelectedIndex=[...filteredSelectedIndex,index]
            }
            return {
                ...prevState,
                selectedOrderIndex:filteredSelectedIndex
            }
        })
    }

    render = () => {
        const { orders } = this.props

        const getOrderTitle = (order) => {
            if (order?.orderItems?.[0]?.orderItemType === "courseFee") {
                return order?.orderItems?.[0]?.courseId
            } else if (order?.orderItems?.[0]?.orderItemType === "batchRegistrationFee") {
                return `Registration for ${order?.orderItems?.[0]?.batchId}`
            } else if (order?.orderItems?.[0]?.orderItemType === "batchFee") {
                return `${order?.orderItems?.[0]?.batchId}`
            }
            return ""
        }
        const getOrderStatus = (order) => {
            const paymentStatus = getOrderPaymentStatus(order) 
            const orderStatus = order?.orderStatus 
            if (paymentStatus === "failed") {
                return "Payment failed"
            } else if (paymentStatus === "paid" && orderStatus === "fullfilled") {
                return "Success"
            } else if (paymentStatus === "paid" && orderStatus !== "fullfilled") {
                return "Payment success. Please contact support if you do not get registration email."
            }
            return ""
        }
        const getOrderStatusColor = (order) => {
            const paymentStatus = getOrderPaymentStatus(order) 
            const orderStatus = order?.orderStatus 
            if (paymentStatus === "failed") {
                return "#ed4c4c"
            } else if (paymentStatus === "paid" && orderStatus === "fullfilled") {
                return "#4ced72"
            } else if (paymentStatus === "paid" && orderStatus !== "fullfilled") {
                return "#edbd4c"
            }
            return ""
        }
        
        return <div className="my-orders-container">
            {Object.values(orders || {}).filter(order => getOrderStatus(order))?.sort((a,b)=>
            b?.createTimestampMillis - a?.createTimestampMillis).map((order, index) => {
                return <div className="order-container" key={order?.orderId}>
                    <div className="header-title">
                        <div className="title-container"> Order ID <h5 className="order-id">{order?.orderId}</h5></div>
                        <div className="status-tag" style={{ backgroundColor: getOrderStatusColor(order) }}>{getOrderStatus(order)}</div>
                    </div>
                    <div className="order-details" >
                        <div>
                            <div>
                                {getOrderTitle(order)}
                            </div><div className="created-date-container">Created on: {new Date(order?.createTimestampMillis || 0).toLocaleString()}</div>
                        </div>
                        <div className="amount-field">Rs. {order?.orderItems?.[0]?.price?.quantity / 100}</div>
                    </div>
                    <div className="accordion-button-container">
                        <div className="more-order-details-button" role="button" tabIndex={0} onClick={() => this.onOrderOpenClick(index)}>
                            {this.state.selectedOrderIndex?.includes(index) && order?.orderItems?.length ? <svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512.01 512.01">
                                <g>
                                    <g>
                                        <path d="M505.755,358.256L271.088,123.589c-8.341-8.341-21.824-8.341-30.165,0L6.256,358.256c-8.341,8.341-8.341,21.824,0,30.165
			s21.824,8.341,30.165,0l219.584-219.584l219.584,219.584c4.16,4.16,9.621,6.251,15.083,6.251c5.462,0,10.923-2.091,15.083-6.251
			C514.096,380.08,514.096,366.597,505.755,358.256z"/>
                                    </g>
                                </g>
                            </svg> : <svg fill="#000000" height="800px" width="800px" version="1.1" 
                            id="Layer_1" viewBox="0 0 330 330" >
                                <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393
	c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393
	s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/>
                            </svg>}


                        </div>
                    </div>
                    {this.state.selectedOrderIndex?.includes(index) &&
                     order?.orderItems?.length ? <TableContainer order={order} /> : null}

                </div>}
            )}
        </div>
    }
}

export const MyOrdersComponent = promReduxConnect(MyOrdersComponentInternal, (state, ownProps) => {
    return {
        orders: state.common.orders
    }
})